import { jsx as _jsx } from "react/jsx-runtime";
import DInput from '../../DInput';
export default function DDatePickerTime({ value, onChange, id, }) {
    return (_jsx(DInput, { className: "d-datepicker-time", type: "time", value: value, id: id, onChange: (time) => {
            onChange === null || onChange === void 0 ? void 0 : onChange(time);
        } }));
}
//# sourceMappingURL=DDatePickerTime.js.map